import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
import {
  getUsersByRole,
  updateStudy,
  getPatientBySessionId,
} from "../../../api/api";
import { RotateSpinner } from "react-spinners-kit";
import { withSnackbar } from "notistack";
import { CircleSpinner } from "react-spinners-kit";
import ArticleIcon from "@mui/icons-material/Article";
import axios from "axios";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: "85%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  margin: theme.spacing(1),
  marginLeft: 0,
  marginTop: 0,
  minHeight: 40,
}));

const QCModal = (props) => {
  console.log(props);
  const [loading, setLoading] = useState(false);
  const [remoteData, setRemoteData] = useState({
    checked: false,
    users: {
      radiographers: [],
      radiologists: [],
    },
  });
  const [editableFields, setEditableFields] = useState({
    AssignedRadiographer: props.procedure.data.AssignedRadiographer,
    AssignedRadiologist: props.procedure.data.AssignedRadiologist,
    SideNote: props.procedure.data.SideNote
      ? props.procedure.data.SideNote
      : "",
    ExamDate: props.procedure.data.ExamDate
      ? props.procedure.data.ExamDate
      : new Date(),
    Priority: props.procedure.data.Priority
      ? props.procedure.data.Priority
      : "LOW",
  });

  const [patientDocs, setPatientDocs] = useState({
    document1: "",
    document2: "",
    document3: "",
  });
  useEffect(() => {
    const getPageRemoteData = async () => {
      const [radiographer_res, radiologist_res] = await Promise.all([
        getUsersByRole("radiographer"),
        getUsersByRole("radiologist"),
      ]);
      const [radiographer_data, radiographer_err] = radiographer_res;
      const [radiologist_data, radiologist_err] = radiologist_res;

      if (radiographer_err) {
        props.enqueueSnackbar(
          `ERROR FETCHING RADIOGRAPHER LIST : ${radiographer_err.message}`,
          {
            preventDuplicate: true,
            variant: "error",
          }
        );
        return;
      } else if (radiologist_err) {
        props.enqueueSnackbar(
          `ERROR FETCHING RADIOLOGISTS LIST : ${radiologist_err.message}`,
          {
            preventDuplicate: true,
            variant: "error",
          }
        );
        return;
      }

      const payload = {
        users: {
          radiographers: radiographer_data.data,
          radiologists: radiologist_data.data,
        },
        checked: true,
      };

      setRemoteData(payload);
    };

    const getPatient = async () => {
      const [patient, err] = await getPatientBySessionId(
        props.procedure.data.SessionID
      );

      console.log({ patient, err });

      if (patient) {
        setPatientDocs({
          document1: patient.data.Documents.ID_DOC,
          document2: patient.data.Documents.MEDICAL_AID_DOC,
          document3: patient.data.Documents.REF_NOTE_DOC,
        });
      } else {
        props.enqueueSnackbar("COULD NOT GET PATIENT DATA", {
          preventDuplicate: true,
          variant: "error",
        });
      }
    };

    getPatient();
    getPageRemoteData();
  }, []);

  const handleChange = (e) => {
    const __this = e.currentTarget;
    const id = __this.id;

    setEditableFields({
      ...editableFields,
      [id]: __this.value,
    });
  };

  const handleSubmit = async () => {
    if (loading) return;

    setLoading(true);

    let worklist = [...props.worklist];
    let currentProcedure = {
      ...props.procedure.data,
      ...editableFields,
      Status: "DICTATE",
    };
    worklist[props.procedure.index] = currentProcedure;

    const [_, err] = await updateStudy(currentProcedure);

    if (!err) {
      setLoading(false);
      props.updateWorklist(worklist);
      props.enqueueSnackbar("QC submission successful", {
        preventDuplicate: true,
        variant: "success",
      });
      props.close();
    } else {
      setLoading(false);
      console.error("Error : ", err);
      props.enqueueSnackbar(`Error : ${err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
    }
  };

  const viewDocument = (document) => {
    
    if (!document) {
      props.enqueueSnackbar(`THE DOCUMENT FOR THIS PATIENT WAS NOT UPLOADED`, {
        preventDuplicate: true,
      });

    } else {
      var w = window.open("about:blank");

      setTimeout(() => {
        w.document.body.appendChild(w.document.createElement("img")).src =
          document;
        w.document.body.style.margin = 0;
        w.document.getElementsByTagName("img")[0].style.width = "100%";
        w.document.getElementsByTagName("img")[0].style.height = "100%";
        w.document.getElementsByTagName("img")[0].style.border = 0;
      }, 0);
    }
    
  };

  return (
    <Modal
      open={true}
      onClose={props.close}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={{ flexGrow: 1, flexWrap: "wrap" }}>
          <Grid container spacing={2}>
            {/* QC RECORD DATA START */}
            <Grid item xs={6}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom component="div">
                    QC Record data
                  </Typography>
                </Grid>

                <Grid item xs={5}>
                  <Item>Name :</Item>
                  <Item>MRN :</Item>
                  <Item>Sex :</Item>
                  <Item>Accession :</Item>
                  <Item>Procedure :</Item>
                </Grid>

                <Grid item xs={7}>
                  <Item>{`${props.procedure.data.FirstName} ${props.procedure.data.LastName}`}</Item>
                  <Item>{props.procedure.data.MRN}</Item>
                  <Item>{props.procedure.data.Sex}</Item>
                  <Item>{props.procedure.data.Accession}</Item>
                  <Item>{props.procedure.data.Procedure}</Item>
                </Grid>
              </Grid>
            </Grid>
            {/*  QC RECORD DATA START*/}

            <Grid item xs={6}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom component="div">
                    Document upload data
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Item
                    onClick={() => viewDocument(patientDocs.document1)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      paddingLeft:'40%'
                    }}
                  >
                    <ArticleIcon sx={{ marginRight: "8px" }} />
                    ID DOC
                  </Item>

                  <Item
                    onClick={() => viewDocument(patientDocs.document2)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      paddingLeft:'40%'
                    }}
                  >
                    <ArticleIcon sx={{marginRight:'8px'  }} />
                    MEDICAL AID DOC
                  </Item>

                  <Item
                    onClick={() => viewDocument(patientDocs.document3)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      paddingLeft:'40%'
                    }}
                  >
                    <ArticleIcon sx={{ marginRight: "8px" }} />
                    REF NOTE DOC
                  </Item>
                  <Item></Item>
                  {/* <Item>File Type :</Item>
                  <Item>Max-size :</Item>
                  <Item>Medical Referral Letter :</Item> */}
                </Grid>

                <Grid item xs={12} sx={{ display: "flex" }}>
                  <Item sx={{ width: "50%" }}>Medical Aid Number :</Item>

                  <Item sx={{ width: "50%" }}>
                    {props.procedure.data.MedicalAidNumber}
                  </Item>
                </Grid>
              </Grid>
            </Grid>

            {!remoteData.checked ? (
              <Grid item md={12}>
                <Box
                  sx={{
                    p: 4,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <CircleSpinner />
                </Box>
              </Grid>
            ) : (
              <>
                <Grid item xs={6}>
                  <TextField
                    select
                    label="Assign a radiographer"
                    id="AssignedRadiographer"
                    value={editableFields.AssignedRadiographer}
                    onChange={handleChange}
                    SelectProps={{
                      native: true,
                    }}
                    fullWidth
                  >
                    <option value={`NONE`}>NONE</option>
                    {remoteData.users.radiographers.map(
                      (radiographer, index) => {
                        return (
                          <option
                            key={"option-" + index}
                            value={radiographer.UserName}
                          >
                            {radiographer.FirstName + " "+ radiographer.LastName}
                          </option>
                        );
                      }
                    )}
                  </TextField>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    select
                    label="Assign a radiologist"
                    id="AssignedRadiologist"
                    value={editableFields.AssignedRadiologist}
                    onChange={handleChange}
                    SelectProps={{
                      native: true,
                    }}
                    fullWidth
                  >
                    <option value={`NONE`}>NONE</option>
                    {remoteData.users.radiologists.map((radiologist, index) => {
                      return (
                        <option
                          key={"option-" + index}
                          value={radiologist.UserName}
                        >{`${radiologist.FirstName + " "+ radiologist.LastName}`}</option>
                      );
                    })}
                  </TextField>
                </Grid>
              </>
            )}

            <Grid item xs={6}>
              <TextField
                select
                id="Priority"
                label=" Priority reporting"
                value={editableFields.Priority}
                onChange={handleChange}
                SelectProps={{
                  native: true,
                }}
                fullWidth
              >
                <option value={"LOW"}>Low</option>
                <option value={"MEDIUM"}>Medium</option>
                <option value={"HIGH"}>High</option>
              </TextField>
            </Grid>

            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={new Date(editableFields.ExamDate)}
                  onChange={(newValue) => {
                    setEditableFields({
                      ...editableFields,
                      ExamDate: new Date(newValue).getTime(),
                    });
                  }}
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} label="Schedule" />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField
                    id="SideNote"
                    label="Type exam notes here"
                    sx={{ mt: 2 }}
                    multiline
                    rows={4}
                    fullWidth
                    value={editableFields.SideNote}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Stack
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    spacing={2}
                    sx={{ height: "100%" }}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      size="large"
                      onClick={() => {
                        if (!loading) {
                          props.close();
                        }
                      }}
                      sx={{ mr: 1, minWidth: 150, minHeight: 42 }}
                    >
                      Cancel
                    </Button>

                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      onClick={handleSubmit}
                      style={{ minWidth: 150, minHeight: 42 }}
                    >
                      {loading ? (
                        <RotateSpinner size={20} color="#fff" />
                      ) : (
                        <>End_Exam</>
                      )}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default withSnackbar(QCModal);
